import { CardSchema } from "./card";
import { ProductCodeSchema } from "./product";
import { FeaturesSummary } from "./features";
import { BillingIntervalSchema } from "./price";
import { z } from "zod";
import { nullishToOptional } from "../helpers";

export const StripeSubscriptionStatusSchema = z.enum([
  "trialing",
  "active",
  "past_due",
  "canceled",
  "unpaid",
  "incomplete_expired",
  "incomplete",
  "unknown",
]);

export const InternalStatusSchema = z.enum(["active", "suspended", "gracePeriod", "cancelled", "downgraded_to_free"]);

export const BillingTypeSchema = z.enum(["Auto", "Invoice"]);

export type StripeSubscriptionStatus = z.infer<typeof StripeSubscriptionStatusSchema>;
export type InternalStatus = z.infer<typeof InternalStatusSchema>;
export type BillingType = z.infer<typeof BillingTypeSchema>;

export const StripeSubscriptionStatus = StripeSubscriptionStatusSchema.enum;
export const InternalStatus = InternalStatusSchema.enum;
export const BillingType = BillingTypeSchema.enum;

export const Subscription = z.object({
  card: nullishToOptional(CardSchema),

  seats: z.number(),
  seatLimit: z.number(),

  status: nullishToOptional(InternalStatusSchema),
  subscriptionStatus: nullishToOptional(StripeSubscriptionStatusSchema),
  internalStatus: nullishToOptional(InternalStatusSchema),

  stripeSubscriptionId: nullishToOptional(z.string()),
  stripeCustomerId: nullishToOptional(z.string()),

  product: ProductCodeSchema,
  planPriceId: z.string(),
  planInterval: BillingIntervalSchema,

  currentPeriodStart: nullishToOptional(z.string()),
  currentPeriodEnd: nullishToOptional(z.string()),
  cancelAt: nullishToOptional(z.string()),

  subscriptionStatusUpdatedAt: nullishToOptional(z.string()),
});

export type Subscription = z.infer<typeof Subscription>;
